<template>
  <div v-if="date && timezone">
    <div class="date-output">
      {{ this.formatDate(date) }}
    </div>
    <div class="timezone-output">
      {{ this.formatTimezone(timezone) }}
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';

export default {
  props: {
    date: {
      type: String,
      default: null
    },
    timezone: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState('global', [
      'momentLocale',
      'momentDateFormat',
      'momentTimeFormat',
      'timezones'
    ])
  },
  methods: {
    formatTimezone(timezone) {
      return (this.timezones.find(tz => tz.id === timezone) || {}).name;
    },
    formatDate(date) {
      return moment(date)
        .locale(this.momentLocale)
        .format(this.momentDateFormat + ' ' + this.momentTimeFormat);
    }
  }
};
</script>
